import React from "react";

const DeliveredIcon = () => {
  return (
    <svg
      width="56"
      height="56"
      viewBox="0 0 38 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        opacity="0.2"
        x="0.788818"
        y="0.572876"
        width="36.8348"
        height="37.0051"
        rx="18.4174"
        fill="#05C168"
      />
      <path
        d="M16.5501 25L10.8501 19.3L12.2751 17.875L16.5501 22.15L25.7251 12.975L27.1501 14.4L16.5501 25Z"
        fill="#029F04"
      />
    </svg>
  );
};

export default DeliveredIcon;
